import React, { useState } from 'react';
import { Badge, Popover, Empty } from 'antd';
import { NotificationsNone } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import useNotifications from '../../hooks/useNotifications';
import './notificationBell.css';

// Cloche de notifications (Topbar staff + navbar livreur). Autonome :
// monte le hook de polling, affiche le badge « non vues », ouvre un panneau
// listant les dernières notifications ; le tap mène à la page concernée.
const NotificationBell = ({ className = 'topbar-icons' }) => {
  const navigate = useNavigate();
  const { items, unseen, markAllSeen } = useNotifications({ onNavigate: navigate });
  const [open, setOpen] = useState(false);

  const onOpenChange = (v) => {
    setOpen(v);
    if (v) markAllSeen();
  };

  const contenu = (
    <div className="nbell-panel">
      <div className="nbell-head">
        <b>Notifications</b>
        <button type="button" className="nbell-prefs" onClick={() => { setOpen(false); navigate('/preferences-notifications'); }}>
          Paramètres
        </button>
      </div>
      {!items.length ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Rien de nouveau" />
      ) : (
        <div className="nbell-list">
          {items.map((n) => (
            <button
              type="button"
              key={n.id_event}
              className="nbell-item"
              onClick={() => { setOpen(false); if (n.route) navigate(n.route); }}
            >
              <b>{n.titre}</b>
              {n.corps ? <span>{n.corps}</span> : null}
              <small>{n.quand}</small>
            </button>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <Popover
      content={contenu}
      trigger="click"
      open={open}
      onOpenChange={onOpenChange}
      placement="bottomRight"
      overlayClassName="nbell-popover"
    >
      <div className={className} role="button" aria-label={`Notifications${unseen ? ` (${unseen} non vues)` : ''}`}>
        <Badge count={unseen} size="small" offset={[2, -2]}>
          <NotificationsNone />
        </Badge>
      </div>
    </Popover>
  );
};

export default NotificationBell;
